import SelectorValue from 'domain/entity/preset/field/selectorValue';
import { SELECTOR_SHOW_AS } from 'domain/entity/preset/form/presetFormField';

export default class PresetFormFieldProperties {
    constructor(
        readonly placeholder?: string,
        readonly maxLength?: number,
        readonly showAs?: SELECTOR_SHOW_AS,
        readonly defaultValues?: SelectorValue[],
        readonly pageSize?: number
    ) {}
}
